import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center gap-3 mb-2"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "home" }
const _hoisted_4 = { class: "row mt-5" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-10 offset-md-1"
}
const _hoisted_6 = {
  key: 1,
  class: "col-md-10 offset-md-1"
}
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-header text-center" }
const _hoisted_10 = { class: "input-group chat-input" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary btn-lg",
  type: "submit"
}, "Send ", -1)
const _hoisted_12 = {
  class: "card-body p-2",
  style: {"height":"400px","overflow-y":"scroll"}
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "card-footer" }
const _hoisted_15 = { class: "text-center m-0 p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeletor = _resolveComponent("Skeletor")!
  const _component_ChatPeopleBar = _resolveComponent("ChatPeopleBar")!
  const _component_EmojiPicker = _resolveComponent("EmojiPicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
              return _createVNode(_component_Skeletor, {
                key: index,
                width: "140",
                height: "46",
                pill: ""
              })
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_ChatPeopleBar, { peopleList: _ctx.getPeopleList }, null, 8, ["peopleList"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_Skeletor, {
                width: "100%",
                height: "400"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, "Chat with: " + _toDisplayString(_ctx.getFullName), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("form", {
                    ref: "messageForm",
                    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_EmojiPicker, {
                        "static-texts": { placeholder: 'Search emoji'},
                        "hide-group-icons": true,
                        "hide-search": true,
                        native: true,
                        "disable-skin-tones": true,
                        text: _ctx.newMessage,
                        "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newMessage) = $event)),
                        "picker-type": "textarea"
                      }, null, 8, ["text"]),
                      _hoisted_11
                    ])
                  ], 544)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentChat.messages, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["d-flex mb-3", message.author === _ctx.currentUser?._id ? 'justify-content-start' : 'justify-content-end']),
                      key: message._id
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["p-2 rounded shadow-sm", message.author === _ctx.currentUser?._id ? 'bg-white' : 'bg-secondary text-white']),
                        innerHTML: _ctx.parseMessage(message.message)
                      }, null, 10, _hoisted_13)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, [
                    _createElementVNode("small", null, "Chat with " + _toDisplayString(_ctx.getFullName), 1)
                  ])
                ])
              ])
            ]))
      ])
    ])
  ]))
}